(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || window.__lustTikTokPixelLoaded) return;
  window.__lustTikTokPixelLoaded = true;

  var pixelId = script.dataset.pixelId;
  if (!pixelId) return;

  !function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = w[t] = w[t] || [];
    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
    ttq.setAndDefer = function (obj, method) {
      obj[method] = function () {
        obj.push([method].concat([].slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (id) {
      var instance = ttq._i[id] || [];
      for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(instance, ttq.methods[j]);
      return instance;
    };
    ttq.load = function (id, options) {
      var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[id] = [];
      ttq._i[id]._u = url;
      ttq._t = ttq._t || {};
      ttq._t[id] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[id] = options || {};
      var el = d.createElement('script');
      el.type = 'text/javascript';
      el.async = true;
      el.src = url + '?sdkid=' + id + '&lib=' + t;
      var first = d.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(el, first);
    };
    ttq.load(pixelId);
    ttq.page();
  }(window, document, 'ttq');

  var productId = script.dataset.productId || '';
  var variantId = script.dataset.variantId || productId;
  var productTitle = script.dataset.productTitle || document.title;
  var currency = script.dataset.currency || 'USD';
  var value = parseFloat(script.dataset.value || '0') || 0;
  var isProduct = script.dataset.pageType === 'product';
  var recent = {};

  function eventId(name) {
    return ['lust', name, Date.now(), Math.random().toString(36).slice(2, 10)].join('_');
  }

  function contents(quantity, item) {
    item = item || {};
    var itemId = item.variantId || variantId || productId;
    if (!itemId) return [];
    return [{
      content_id: String(itemId),
      content_type: 'product',
      content_name: item.title || productTitle,
      quantity: quantity || 1,
      price: typeof item.value === 'number' ? item.value : value
    }];
  }

  function track(name, quantity, item) {
    item = item || {};
    var itemId = item.variantId || variantId || productId;
    var itemTitle = item.title || productTitle;
    var itemValue = typeof item.value === 'number' ? item.value : value;
    var key = name + ':' + itemId;
    var now = Date.now();
    if (recent[key] && now - recent[key] < 1500) return;
    recent[key] = now;
    var props = {
      content_type: 'product',
      currency: currency
    };
    if (itemId) props.content_id = String(itemId);
    if (itemTitle) props.content_name = itemTitle;
    if (itemId) props.contents = contents(quantity, item);
    if (quantity) props.quantity = quantity;
    if (itemValue > 0) props.value = itemValue * (quantity || 1);
    window.ttq.track(name, props, { event_id: eventId(name) });
  }

  if (isProduct) track('ViewContent', 1);

  function quantityFromBody(body) {
    try {
      if (body instanceof FormData) return parseInt(body.get('quantity') || '1', 10) || 1;
      if (body instanceof URLSearchParams) return parseInt(body.get('quantity') || '1', 10) || 1;
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') return parseInt(JSON.parse(body).quantity || '1', 10) || 1;
        return parseInt(new URLSearchParams(body).get('quantity') || '1', 10) || 1;
      }
    } catch (_) {}
    return 1;
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = nativeFetch.apply(this, arguments);
      if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
        promise.then(function (response) {
          if (!response || !response.ok) return;
          var fallbackQuantity = quantityFromBody(init && init.body);
          response.clone().json().then(function (added) {
            var line = added && added.items ? added.items[0] : added;
            line = line || {};
            track('AddToCart', parseInt(line.quantity || fallbackQuantity, 10) || 1, {
              variantId: line.variant_id || line.id || '',
              title: line.product_title || line.title || '',
              value: typeof line.final_price === 'number'
                ? line.final_price / 100
                : (typeof line.price === 'number' ? line.price / 100 : 0)
            });
          }).catch(function () {
            track('AddToCart', fallbackQuantity);
          });
        }).catch(function () {});
      }
      return promise;
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action) return;
    if (/\/cart\/add(?:\?|$)/.test(form.action)) {
      window.setTimeout(function () {
        track('AddToCart', quantityFromBody(new FormData(form)));
      }, 0);
    }
    if (/\/cart(?:\?|$)/.test(form.action) && form.querySelector('[name="checkout"]')) {
      track('InitiateCheckout', 1);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a,button') : null;
    if (!target) return;
    var href = target.getAttribute('href') || '';
    var name = target.getAttribute('name') || '';
    if (/\/checkout(?:\?|$)/.test(href) || name === 'checkout') track('InitiateCheckout', 1);
  }, true);
}());
